"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MILLIS_PER_SECOND = 1000;
var MILLIS_PER_MINUTE = MILLIS_PER_SECOND * 60;
var MILLIS_PER_HOUR = MILLIS_PER_MINUTE * 60;
var MILLIS_PER_DAY = MILLIS_PER_HOUR * 24;

var TimeSpan = function () {
  function TimeSpan(days, hours, minutes, seconds, milliseconds) {
    if (seconds === void 0) {
      seconds = 0;
    }

    if (milliseconds === void 0) {
      milliseconds = 0;
    }

    this._totalMilliseconds = 0;
    var totalmilliseconds = days * MILLIS_PER_DAY + hours * MILLIS_PER_HOUR + minutes * MILLIS_PER_MINUTE + seconds * MILLIS_PER_SECOND + Math.floor(milliseconds);
    this._totalMilliseconds = Math.round(totalmilliseconds);
  }

  TimeSpan.prototype._getSign = function () {
    if (this._totalMilliseconds < 0) {
      return -1;
    } else {
      return 1;
    }
  };

  TimeSpan.prototype._floor = function (value) {
    return this._getSign() * Math.floor(Math.abs(value));
  };

  Object.defineProperty(TimeSpan.prototype, "days", {
    get: function get() {
      return this._floor(this.totalDays);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(TimeSpan.prototype, "hours", {
    get: function get() {
      return this._floor(this.totalHours % 24);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(TimeSpan.prototype, "minutes", {
    get: function get() {
      return this._floor(this.totalMinutes % 60);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(TimeSpan.prototype, "seconds", {
    get: function get() {
      return this._floor(this.totalSeconds % 60);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(TimeSpan.prototype, "milliseconds", {
    get: function get() {
      return this._floor(this._totalMilliseconds % MILLIS_PER_SECOND);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(TimeSpan.prototype, "totalDays", {
    get: function get() {
      return this._totalMilliseconds / MILLIS_PER_DAY;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(TimeSpan.prototype, "totalHours", {
    get: function get() {
      return this._totalMilliseconds / MILLIS_PER_HOUR;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(TimeSpan.prototype, "totalMinutes", {
    get: function get() {
      return this._totalMilliseconds / MILLIS_PER_MINUTE;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(TimeSpan.prototype, "totalSeconds", {
    get: function get() {
      return this._totalMilliseconds / MILLIS_PER_SECOND;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(TimeSpan.prototype, "totalMilliseconds", {
    get: function get() {
      return this._totalMilliseconds;
    },
    enumerable: true,
    configurable: true
  });

  TimeSpan.areEquals = function (ts1, ts2) {
    return ts1.totalMilliseconds === ts2.totalMilliseconds;
  };

  TimeSpan.parse = function (text) {
    if (!text) {
      throw new Error('Null, undefined or empty string not allowed for TimeSpan format');
    }

    var components = text.split(/:/);

    if (components.length < 2) {
      throw new Error('Invalid TimeSpan input format ' + text);
    }

    var days = 0;
    var hours = 0;
    var minutes = 0;
    var seconds = 0;
    var milliseconds = 0;
    var daysAndHours = components[0].split(/\./);

    if (daysAndHours.length === 2) {
      days = parseInt(daysAndHours[0]);
      hours = parseInt(daysAndHours[1]);
    } else {
      hours = parseInt(daysAndHours[0]);
    }

    minutes = parseInt(components[1]);

    if (components.length === 3) {
      var secondsAndMilliseconds = components[2].split(/\./);

      if (secondsAndMilliseconds.length === 2) {
        seconds = parseInt(secondsAndMilliseconds[0]);
        milliseconds = TimeSpan._parseMilliseconds(secondsAndMilliseconds[1]);
      } else {
        seconds = parseInt(secondsAndMilliseconds[0]);
      }
    }

    return new TimeSpan(days, hours, minutes, seconds, milliseconds);
  };

  TimeSpan._parseMilliseconds = function (ms) {
    var milliseconds = parseInt(ms);

    if (milliseconds <= 999) {
      return milliseconds;
    }

    while (milliseconds > 999) {
      milliseconds = milliseconds / 10;
    }

    return Math.round(milliseconds);
  };

  TimeSpan.fromMilliseconds = function (totalMilliseconds) {
    return new TimeSpan(0, 0, 0, 0, totalMilliseconds);
  };

  TimeSpan.fromSeconds = function (totalSeconds) {
    return new TimeSpan(0, 0, 0, totalSeconds, 0);
  };

  TimeSpan.fromMinutes = function (totalMinutes) {
    return new TimeSpan(0, 0, totalMinutes, 0, 0);
  };

  TimeSpan.fromHours = function (totalHours) {
    return new TimeSpan(0, totalHours, 0, 0, 0);
  };

  TimeSpan.fromDays = function (days) {
    return new TimeSpan(days, 0, 0, 0, 0);
  };

  TimeSpan.prototype.subtract = function (timeSpan) {
    if (!timeSpan) {
      throw new Error('timeSpan argument cannot be null or undefined');
    }

    var milliseconds = this.totalMilliseconds - timeSpan.totalMilliseconds;
    return TimeSpan.fromMilliseconds(milliseconds);
  };

  TimeSpan.prototype.add = function (timeSpan) {
    if (!timeSpan) {
      throw new Error('timeSpan argument cannot be null or undefined');
    }

    var totalMilliseconds = this.totalMilliseconds + timeSpan.totalMilliseconds;
    return TimeSpan.fromMilliseconds(totalMilliseconds);
  };

  TimeSpan.prototype.toString = function () {
    if (this._totalMilliseconds < 0) return '-' + TimeSpan.fromMilliseconds(-this._totalMilliseconds).toString();
    var result = '';

    if (this.days > 0) {
      result += this.days.toString() + '.';
    }

    result += this.hours.toString().padStart(2, '0') + ':';
    result += this.minutes.toString().padStart(2, '0') + ':';
    result += this.seconds.toString().padStart(2, '0');

    if (this.milliseconds > 0) {
      result += '.' + this.milliseconds.toString().padStart(3, '0');
    }

    return result;
  };

  TimeSpan.prototype.toHoursAndMinutesString = function () {
    return this.hours.toString().padStart(2, '0') + ':' + this.minutes.toString().padStart(2, '0');
  };

  TimeSpan.prototype.toLocalTime = function () {
    var localTime = new Date();
    localTime.setUTCHours(this.hours);
    localTime.setUTCMinutes(this.minutes);
    localTime.setUTCSeconds(this.seconds);
    localTime.setUTCMilliseconds(this.milliseconds);
    return new TimeSpan(0, localTime.getHours(), localTime.getMinutes(), localTime.getSeconds(), localTime.getMilliseconds());
  };

  return TimeSpan;
}();

exports.TimeSpan = TimeSpan;